// extracted by mini-css-extract-plugin
export default {"wrapper":"Face_style_wrapper__10ysw","content":"Face_style_content__d4-xr","rotate":"Face_style_rotate__7cTcv"};